import ConfirmPasswordReset from './ConfirmPasswordReset'

export default ConfirmPasswordReset
